module.exports = __webpack_public_path__ + "static/media/Andre_Marquet.0ff135f0.jpg";